export enum EEtatFacturationSeance {
	All = "all",
	Some = "some",
	None = "none",
	Default = ''
}
